import { render } from "./NodeEditor.vue?vue&type=template&id=b6641612&scoped=true"
import script from "./NodeEditor.vue?vue&type=script&lang=js"
export * from "./NodeEditor.vue?vue&type=script&lang=js"

import "./NodeEditor.vue?vue&type=style&index=0&id=b6641612&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6641612"]])

export default __exports__